import React, { memo } from 'react'
import { Hidden, IconButton } from '@material-ui/core'
import { ReactComponent as Instagram } from '../../assets/svgs/footer-instagram.svg'
import { ReactComponent as FacebookBox } from '../../assets/svgs/footer-facebook.svg'
import { ReactComponent as Blogger } from '../../assets/svgs/footer-blogger.svg'
import { ReactComponent as Whatsapp } from '../../assets/svgs/footer-whatsapp.svg'
import * as Styled from './styled'
import { ReactComponent as Logo } from '../../assets/svgs/logo-footer.svg'
import CONTACT_ITEMS from './constants/items'
import ContactItem from './components/ContactItem'
import { ReactComponent as Ans } from '../../assets/svgs/ans.svg'

const Footer = ({ footerWrapperStyle }) => {
  return (
    <Styled.Wrapper style={footerWrapperStyle}>
      <Styled.TopWrapper>
        <Styled.Logo>
          <Logo alt='W.Dental' />
        </Styled.Logo>
        <Styled.SocialLinksContainer>
          <IconButton
            size='small'
            color='inherit'
            aria-label='Acessar o Instagram da W.Dental'
          >
            <a
              href='https://www.instagram.com/w.dental_br/'
              rel='noopener noreferrer'
              target='_blank'
            >
              <Instagram style={{ height: '40px', width: '40px' }} />
            </a>
          </IconButton>

          <IconButton
            size='small'
            color='inherit'
            aria-label='Acessar o Facebook da W.Dental'
          >
            <a
              href='https://www.facebook.com/W.Dental.br/'
              rel='noopener noreferrer'
              target='_blank'
            >
              <FacebookBox style={{ height: '40px', width: '40px' }} />
            </a>
          </IconButton>

          <IconButton
            size='small'
            color='inherit'
            aria-label='Acessar o Blog da W.Dental'
          >
            <a
              href='https://saude.w.dental/'
              rel='noopener noreferrer'
              target='_blank'
            >
              <Blogger style={{ height: '40px', width: '40px' }} />
            </a>
          </IconButton>

          <IconButton
            size='small'
            color='inherit'
            aria-label='Contato via whatsapp da W.Dental'
          >
            <a
              href='https://wa.me/5521970646570'
              rel='noopener noreferrer'
              target='_blank'
            >
              <Whatsapp style={{ height: '40px', width: '40px' }} />
            </a>
          </IconButton>
        </Styled.SocialLinksContainer>
      </Styled.TopWrapper>

      <Styled.ContactsArea>
        {CONTACT_ITEMS.map((item, i) => (
          <ContactItem {...item} key={i} />
        ))}
      </Styled.ContactsArea>

      <Styled.ANS>
        <Ans alt='ANS - No. 421049' />
      </Styled.ANS>

      <Styled.FooterInfos>
        <Styled.AddressPart>W.Dental | CRO/RJ | EPAO: 4781</Styled.AddressPart>
        <Styled.AddressPart hasSpacing>
          Responsável Técnico Dr. Michell Giordano de Oliveira
        </Styled.AddressPart>
        <Styled.AddressPart hasSpacing>
          CRO/RJ: 40049 | CNPJ: 27.119.150/0001-75
        </Styled.AddressPart>
        <Styled.AddressPart
          as='a'
          href='https://www.google.com/maps/place/Downtown/@-23.003571,-43.3194957,17z/data=!3m1!4b1!4m5!3m4!1s0x9bd0bafdf65637:0x5aec2654261140ac!8m2!3d-23.003571!4d-43.317307'
          target='_blank'
          rel='noopener noreferrer'
        >
          Av das Américas 500, bloco 21, sala 238
          <p>Downtown - Barra da Tijuca</p>
        </Styled.AddressPart>
      </Styled.FooterInfos>
    </Styled.Wrapper>
  )
}

export default memo(Footer)
